import { IComponentOptions } from 'angular';
import { DateTimeStepCtrl } from './date-time-step.controller';

export const DateTimeStepComponent: IComponentOptions = {
  template: require('./date-time-step.html'),
  bindings: {
    nextStep: '&',
    prevStep: '&',
    currentSupport: '<',
    currentSchool: '<',
  },
  controller: DateTimeStepCtrl,
};

angular.module('nv.SupportsModule').component('dateTimeStep', DateTimeStepComponent);
